import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import DeliveryTerm, { IGetDeliveryTermDto } from "./DeliveryTerm"

export interface IGetDeliveryTermsDto {
    entities?: IGetDeliveryTermDto[] | null
    links: IApiLink[]
}

export default class DeliveryTerms {
    entities: DeliveryTerm[]
    linkCreate?: IApiLink

    constructor(dto: IGetDeliveryTermsDto) {
        this.entities = dto.entities?.map(e => new DeliveryTerm(e)) || []
        this.linkCreate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsDeliveryTerms && lnk.rel === ApiLinkRel.new)
    }
}
